import { API, HOST } from '@/utils/http'
import { toast } from "@/components/ui/toast/use-toast"

export const fetchOrgs = async ({commit}) => {
  try {
    const response = await API({
      method: 'GET',
      url: `${HOST}/organization`
    })

    commit('SET_ORGS', response.data)
  } catch (e) {
    toast({ title: "Can't fetch orgs", variant: 'destructive' })
  }
}

export const fetchOrg = async ({commit}, orgId) => {
  try {
    const response = await API({
      method: 'GET',
      url: `${HOST}/organization/${orgId}`
    })

    commit('SET_CURRENT', response.data)
  } catch (e) {
    toast({ title: `Can't fetch org. ID: ${orgId}`, variant: 'destructive' })
  }
}

export const fetchOrgMembers = async ({commit}, orgId) => {
  try {
    const response = await API({
      method: 'GET',
      url: `${HOST}/organization/${orgId}/members`
    })

    commit('SET_CURRENT_MEMBERS', response.data)
  } catch (e) {
    toast({ title: `Can't fetch org members. ID: ${orgId}`, variant: 'destructive' })
  }
}

export const fetchOrgInvites = async ({commit}, orgId) => {
  try {
    const response = await API({
      method: 'GET',
      url: `${HOST}/organization/${orgId}/invites`
    })

    commit('SET_CURRENT_INVITES', response.data)
  } catch (e) {
    toast({ title: `Can't fetch org invites. ID: ${orgId}`, variant: 'destructive' })
  }
}

export const createOrg = async ({commit}, payload) => {
  try {
    const response = await API({
      method: 'POST',
      url: `${HOST}/organization`,
      data: {
        organization_name: payload.name,
      }
    })

    commit('ADD_ORG', response.data)
    toast({ title: 'Organization created' })
  } catch (e) {
    if (e.response.status === 400) {
      toast({ title: 'Organization with this name already exists', variant: 'destructive' })
    } else {
      toast({ title: `Can't create organization`, variant: 'destructive' })
    }
  }
}

export const invite = async ({commit}, payload) => {
  const orgId = payload.organization_id

  try {
    const response = await API({
      method: 'POST',
      url: `${HOST}/organization/${orgId}/invite`,
      data: payload
    })

    commit('ADD_INVITE', response.data)
    toast({ title: `Invite sent to ${payload.email}` })
  } catch (e) {
    if (e.response.status === 409) {
      toast({ title: 'User already in organization', variant: 'destructive' })
    } else if (e.response.status === 400) {
      toast({ title: `${e.response.data?.detail}`, variant: 'destructive' })
    } else {
      toast({ title: `Can't create invite. ${e.response.data?.detail}`, variant: 'destructive' })
    }
  }
}


export const updateMember = async ({commit}, payload) => {
  try {
    const response = await API({
      method: 'PUT',
      url: `${HOST}/organization/${payload.orgId}/members/${payload.orgMemberId}`,
      data: {
        display_name: payload.displayName,
        role: payload.role,
        key_settings: payload.keySettings
      }
    })
    commit('UPDATE_MEMBER', response.data)
    toast({ title: 'Member updated' })
  } catch (e) {
    toast({ title: `Can't update member. ${e.response.data?.detail}`, variant: 'destructive' })
  }
}

export const deleteMember = async ({commit}, payload) => {
  try {
    await API({
      method: 'DELETE',
      url: `${HOST}/organization/${payload.orgId}/members/${payload.orgMemberId}`
    })
    commit('REMOVE_MEMBER', payload.orgMemberId)
    toast({ title: 'Member deleted' })
  } catch (e) {
    toast({ title: `Can't delete member. ${e.response.data?.detail}`, variant: 'destructive' })
  }
}

export const fetchApikeys = async ({commit}, orgId) => {
  try {
    const response = await API({
      method: 'GET',
      url: `${HOST}/organization/${orgId}/apikeys`
    })

    commit('SET_APIKEYS', response.data)
  } catch (e) {
    toast({ title: `Can't get apikeys`, variant: 'destructive' })
  }
}

export const removeApiKey = async ({commit}, payload) => {
  try {
    const response = await API({
      method: 'DELETE',
      url: `${HOST}/organization/${payload.organization_id}/apikeys/${payload.uuid}`
    })

    commit('REMOVE_APIKEY', payload.uuid)
  } catch (e) {
    toast({ title: `Can't delete apikey`, variant: 'destructive' })
  }
}

export const addApiKey = async ({commit}, payload) => {
  try {
    const response = await API({
      method: 'POST',
      url: `${HOST}/organization/${payload.orgId}/apikeys`,
      data: {
        organization_id: payload.orgId,
        name: payload.name,
        key: payload.apikey
      }
    })

    commit('ADD_APIKEY', response.data)
  } catch (e) {
    console.log('error', e)
  }
}

export const setApiKeyAccess = async ({commit}, payload) => {
  try {
    const response = await API({
      method: 'POST',
      url: `${HOST}/organization/${payload.orgId}/members/${payload.orgMemberId}/apikey`
    })

    toast({ title: 'Access updated' })
  } catch (e) {
    console.log(e)
  }
}

export const updateApiKeySettings = async ({commit}, payload) => {
  try {
    await API({
      method: 'PUT',
      url: `${HOST}/organization/${payload.orgId}/members/${payload.orgMemberId}/apikey`,
      data: {
        settings: payload.keySettings
      }
    })
    toast({ title: 'Access updated' })
  } catch (e) {
    console.log(e)
  }
}

export const setSelectedOrg = async ({commit, dispatch}, payload) => {
  try {
    const orgId = payload

    localStorage.setItem('selectedOrgId', orgId)

    commit('SET_SELECTED_ORG', orgId)

    if (orgId) {
      await dispatch('layers/fetchOrgLayers', { orgId }, { root: true })
    }
  } catch (e) {
    toast({ title: 'Failed to set selected organization', variant: 'destructive' })
  }
}

export const initSelectedOrg = ({commit, dispatch, state}) => {
  try {
    if (state.orgs.length > 0) {
      const storedOrgId = localStorage.getItem('selectedOrgId')
      let selectedOrgId

      if (storedOrgId && state.orgs.some(o => o.organization_id === parseInt(storedOrgId))) {
        selectedOrgId = storedOrgId
      } else {
        selectedOrgId = state.orgs[0].organization_id.toString()
      }

      dispatch('setSelectedOrg', selectedOrgId)
    }
  } catch (e) {
    toast({ title: 'Failed to initialize selected organization', variant: 'destructive' })
  }
}
